import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { ErpSyncRegistryPage } from '@pages/erp-sync-registry';

export const Route = createFileRoute('/$locale/_authenticated/erp-sync/registry')({
  validateSearch: z.object({
    scheduledSyncMode: z.enum(['disabled', 'enabled', 'paused']).optional(),
  }),
  component: ErpSyncRegistryRoute,
});

function ErpSyncRegistryRoute() {
  const { locale } = Route.useParams();
  const navigate = useNavigate();
  const search = Route.useSearch();

  return (
    <ErpSyncRegistryPage
      mode="registry"
      initialScheduledSyncMode={search.scheduledSyncMode}
      onScheduledSyncModeChange={(scheduledSyncMode) => {
        void navigate({
          to: '/$locale/erp-sync/registry',
          params: { locale },
          search: { scheduledSyncMode },
          replace: true,
        });
      }}
      onViewHistory={(contractKey) => {
        void navigate({
          to: '/$locale/erp-sync/evidence',
          params: { locale },
          search: { contract: contractKey },
        });
      }}
      onOpenMapping={(contractKey) => {
        void navigate({
          to: '/$locale/erp-sync/mapping',
          params: { locale },
          search: { contract: contractKey },
        });
      }}
    />
  );
}
